import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { ERTUserService } from "../../services/ert-user/ert-user.service";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
import { PicklistService } from "../../services/administration/picklist/picklist.service";
import { ertUserSizes } from "../../interfaces/ert-user/ert-user-sizes";
import { MatTableDataSource } from "@angular/material/table";
import { Kr998Service } from "../../services/kr998/kr998.service";
import { forkJoin } from "rxjs";
import { EducationService } from "../../services/education/education.service";
import { ERTEducation } from "../../interfaces/ert-education/ert-education";
import { FireDepartmentsBcTurnoversService } from "../../services/firedepartments/fireDepartmentsBcTurnovers.service";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "app-ert-user-view",
  templateUrl: "./ert-user-view.component.html",
  styleUrl: "./ert-user-view.component.css",
  animations: [
    trigger("iconRotate", [
      state("open", style({ transform: "rotate(0deg)" })),
      state("closed", style({ transform: "rotate(90deg)" })),
      transition("open <=> closed", [animate("0.3s")]),
    ]),
  ],
})
export class ErtUserViewComponent implements OnInit {
  currentUser: ERTUser;
  isUserLoading = false;
  isUserUpdating = false;
  formattedHireDate: string;
  formattedWithdrewDate: string;
  formattedErtDate: string;
  userNumber: string;
  ertUserViewForm: FormGroup;
  @ViewChild("fileInput") fileInput: ElementRef;

  validationMessages: string[] = [];

  empInfoPanelOpenState = true;
  addInfoPanelOpenState = true;
  personalInfoPanelOpenState = true;
  mgcccInfoPanelOpenState = true;
  employeePicturePanelOpenState = true;

  empKR998Details = new MatTableDataSource([]);
  empErtEduDetails = new MatTableDataSource<ERTEducation>();

  edPageSize = 5;
  kr998PageSize = 5;
  totalEduItems: number;
  totalKR998Items: number;
  userId: number;
  schoolAttendedId: number = 0;
  schoolDivisionId: number = 0;

  crewFieldId: number = 0;
  unitFieldId: number = 0;
  divisionFieldId: number = 0;
  titleFieldId: number = 0;
  selectedCrew: IPicklistValuesData;
  selectedUnit: IPicklistValuesData;
  selectedDivision: IPicklistValuesData;
  selectedTitle: IPicklistValuesData;

  displayedERTEduColumns: Map<string, string> = new Map<string, string>([
    ["id", "ERT Education Id"],
    ["schoolAttended", "School Attended"],
    ["schoolDivision", "School Division"],
    ["hours", "Hours"],
    ["options", "Options"],
  ]);
  displayedERTEduColumnsArray: string[] = Array.from(
    this.displayedERTEduColumns.keys()
  );

  displayedERTKR998Columns: Map<string, string> = new Map<string, string>([
    ["kr998DetailsId", "ERT Kr998 Id"],
    ["caiEmail", "Email"],
    ["company", "Company"],
    ["startDateTime", "Attendance Date"],
    ["crew", "Crew"],
    ["options", "Options"],
  ]);
  displayedERTKR998ColumnsArray: string[] = Array.from(
    this.displayedERTKR998Columns.keys()
  );

  @ViewChild("edSort") edSort!: MatSort;
  @ViewChild("edPaginator") edPaginator!: MatPaginator;
  @ViewChild("kr998Sort") kr998Sort!: MatSort;
  @ViewChild("kr998Paginator") kr998Paginator!: MatPaginator;

  selectedTeeShirtSize: string = "-- None --";
  selectedCoatSize: string = "-- None --";
  selectedHatSize: string = "-- None --";
  selectedGlovesSize: string = "-- None --";
  selectedGlassesSize: string = "-- None --";
  selectedTurnoutJacketSize: string = "-- None --";
  selectedTurnoutPantsSize: string = "-- None --";

  currentLoggedInUser: ILoggedUserData;

  sizes = Object.entries(ertUserSizes)
    .filter(([key]) => isNaN(Number(key)))
    .map(([key, value]) => ({
      label: key,
      value: value,
    }));

  userProfileImage: string = ""; // Add this property
  errorMessage: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private ertUserService: ERTUserService,
    private kr998Service: Kr998Service,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private pickListsService: PicklistService,
    private educationService: EducationService,
    private bcTurnOverService: FireDepartmentsBcTurnoversService,
    private loggedInUserService: LoggedUserService,
    private router: Router
  ) {
    this.ertUserViewForm = this.fb.group({
      selectedFacility: ["", Validators.required],
      cai_email: [""],
      isCompletedFCE: [false],
      lastName: ["", Validators.required],
      firstName: ["", Validators.required],
      calledBy: [""],
      phone: [""],
      altPhone: [""],
      hireDate: [""],
      ertDate: [""],
      inactiveDate: [""],
      comments: [""],
      isInstructor: [false],
      isHotWorkEntry: [false],
      isTurnoverAccess: [false],
      isHurricaneWatch: [false],
      mgcccNumber: [""],
      crew: [""],
      unit: [""],
      division: [""],
      title: [""],
      teeShirtSize: [""],
      coatSize: [""],
      hatSize: [""],
      glovesSize: [""],
      glassesSize: [""],
      turnoutJacketSize: [""],
      turnoutPantsSize: [""],
      boot: [""],
      turnoutBoot: [""],
    });
  }

  ngOnInit(): void {
    this.loggedInUserService.getLoggedUserData().subscribe((user) => {
      this.currentLoggedInUser = user;
    });
    this.totalEduItems = this.empErtEduDetails.data.length;
    this.isUserLoading = true;
    forkJoin({
      crew: this.pickListsService.getFieldIdByName("Crew"),
      unit: this.pickListsService.getFieldIdByName("Units"),
      division: this.pickListsService.getFieldIdByName("Division"),
      title: this.pickListsService.getFieldIdByName("Title"),
      schoolAttended: this.pickListsService.getFieldIdByName("school attended"),
      schoolDivision: this.pickListsService.getFieldIdByName("school division"),
    }).subscribe((results) => {
      this.crewFieldId = results.crew || 0;
      this.unitFieldId = results.unit || 0;
      this.divisionFieldId = results.division || 0;
      this.titleFieldId = results.title || 0;
      this.schoolAttendedId = results.schoolAttended || 0;
      this.schoolDivisionId = results.schoolDivision || 0;
      this.route.queryParamMap.subscribe((params) => {
        this.userNumber = params.get("usernumber");
        this.loadData(this.userNumber);
      });
    });
    this.subscribeToSizeChanges();
  }

  loadEducationForUser(userId: string): void {
    this.educationService.getUserEducationByUserId(+userId).subscribe({
      next: (educationDetails) => {
        educationDetails.forEach((ed) => {
          ed.schoolAttended = this.getLastPostedShoolAttended(
            ed.picklistValues
          );
          ed.schoolDivision = this.getLastPostedShoolDivision(
            ed.picklistValues
          );
        });
        this.empErtEduDetails.data = educationDetails;
        this.empErtEduDetails.sort = this.edSort;
        this.empErtEduDetails.paginator = this.edPaginator;
        this.totalEduItems = educationDetails.length;
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getLastPostedShoolAttended(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.bcTurnOverService.getValueForField(
      picklistValues,
      this.schoolAttendedId
    );
    return name;
  }

  getLastPostedShoolDivision(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.bcTurnOverService.getValueForField(
      picklistValues,
      this.schoolDivisionId
    );
    return name;
  }

  private subscribeToSizeChanges() {
    this.ertUserViewForm.get("teeShirtSize").valueChanges.subscribe((value) => {
      this.selectedTeeShirtSize = value;
    });
    this.ertUserViewForm.get("coatSize").valueChanges.subscribe((value) => {
      this.selectedCoatSize = value;
    });
    this.ertUserViewForm.get("hatSize").valueChanges.subscribe((value) => {
      this.selectedHatSize = value;
    });
    this.ertUserViewForm.get("glovesSize").valueChanges.subscribe((value) => {
      this.selectedGlovesSize = value;
    });
    this.ertUserViewForm.get("glassesSize").valueChanges.subscribe((value) => {
      this.selectedGlassesSize = value;
    });
    this.ertUserViewForm
      .get("turnoutJacketSize")
      .valueChanges.subscribe((value) => {
        this.selectedTurnoutJacketSize = value;
      });
    this.ertUserViewForm
      .get("turnoutPantsSize")
      .valueChanges.subscribe((value) => {
        this.selectedTurnoutPantsSize = value;
      });
  }

  getSelectedPicklistField(fieldId: number, fieldName: string) {
    let selectedPicklistValue: any = this.currentUser?.picklistValues.find(
      (x) => x.picklistFieldId === fieldId
    );
    switch (fieldName) {
      case "Crew":
        this.selectedCrew = selectedPicklistValue;
        break;
      case "Units":
        this.selectedUnit = selectedPicklistValue;
        break;
      case "Division":
        this.selectedDivision = selectedPicklistValue;
        break;
      case "Title":
        this.selectedTitle = selectedPicklistValue;
        break;
    }
    return selectedPicklistValue;
  }

  loadData(userNumber: string): void {
    this.isUserLoading = true;
    this.ertUserService
      .getERTUserById(
        Number(userNumber),
        Number(this.currentLoggedInUser.facilityId) || 0
      )
      .subscribe({
        next: (ertUser: ERTUser) => {
          if (
            ertUser.facilityId !== Number(this.currentLoggedInUser.facilityId)
          ) {
            this.isUserLoading = false;
            this.router.navigate(["/no-access"]);
            return;
          }
          this.loadKR998ForUser();
          this.loadEducationForUser(this.userNumber);
          this.currentUser = ertUser;
          if (this.currentUser.hireDate !== null) {
            this.formattedHireDate = new Date(this.currentUser.hireDate)
              .toISOString()
              .split("T")[0];
          }
          if (this.currentUser.withdrewDate !== null) {
            this.formattedWithdrewDate = new Date(this.currentUser.withdrewDate)
              .toISOString()
              .split("T")[0];
          }
          if (this.currentUser.ertDate !== null) {
            this.formattedErtDate = new Date(this.currentUser.ertDate)
              .toISOString()
              .split("T")[0];
          }
          this.ertUserViewForm.patchValue({
            selectedFacility: this.currentUser.facility,
            cai_email: this.currentUser.caiEmail,
            isCompletedFCE: this.currentUser.isCompletedFCE,
            lastName: this.currentUser.lastName,
            firstName: this.currentUser.firstName,
            calledBy: this.currentUser.calledBy,
            phone: this.currentUser.phone,
            altPhone: this.currentUser.altPhone,
            hireDate: this.formattedHireDate,
            ertDate: this.formattedErtDate,
            inactiveDate: this.formattedWithdrewDate,
            comments: this.currentUser.comments,
            isInstructor: this.currentUser.isInstructor,
            isHotWorkEntry: this.currentUser.isHotWorkEntry,
            isTurnoverAccess: this.currentUser.isTurnoverAccess,
            isHurricaneWatch: this.currentUser.isHurricaneWatch,
            mgcccNumber: this.currentUser.mgcccNumber,
            division: this.getSelectedPicklistField(
              this.divisionFieldId,
              "Division"
            )?.id,
            crew: this.getSelectedPicklistField(this.crewFieldId, "Crew")?.id,
            unit: this.getSelectedPicklistField(this.unitFieldId, "Units")?.id,
            title: this.getSelectedPicklistField(this.titleFieldId, "Title")
              ?.id,
            teeShirtSize: this.currentUser.teeShirtSize,
            coatSize: this.currentUser.coatSize,
            hatSize: this.currentUser.hatSize,
            glovesSize: this.currentUser.glovesSize,
            glassesSize: this.currentUser.glassesSize,
            turnoutJacketSize: this.currentUser.turnoutJacketSize,
            turnoutPantsSize: this.currentUser.turnoutPantsSize,
            boot: this.currentUser.boot,
            turnoutBoot: this.currentUser.turnoutBoot,
          });
          this.loadUserPicture();
          this.isUserLoading = false;
        },
        error: (error) => {
          this.isUserLoading = false;
          console.log(error);
        },
      });
  }

  loadUserPicture(): void {
    if (this.currentUser && this.currentUser.id) {
      this.ertUserService
        .getUserPicture(
          this.currentUser.id,
          Number(this.currentLoggedInUser.facilityId) || 0
        )
        .subscribe({
          next: (blob: Blob) => {
            const objectUrl = URL.createObjectURL(blob);
            this.currentUser.userPicture = objectUrl;
          },
          error: (error) => {
            console.log("Error loading user picture:", error);
            // You might want to set a default image here
            this.currentUser.userPicture = "assets/default-user.jpg";
          },
        });
    }
  }

  onCrewSelected(crew: IPicklistValuesData): void {
    this.selectedCrew = crew;
  }

  onUnitSelected(unit: IPicklistValuesData): void {
    this.selectedUnit = unit;
  }

  onDivisionSelected(division: IPicklistValuesData): void {
    this.selectedDivision = division;
  }

  onTitleSelected(title: IPicklistValuesData): void {
    this.selectedTitle = title;
  }

  openFilePicker() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event) {
    this.isUserUpdating = true;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("userId", this.userNumber);
      this.ertUserService
        .uploadFile(formData, Number(this.currentLoggedInUser.facilityId) || 0)
        .subscribe({
          next: (_) => {
            this.errorMessage = [];
            this.loadUserPicture(); // Reload the image after upload
            this.isUserUpdating = false;
          },
          error: (error) => {
            window.alert("An error occurred while uploading the file.");
            console.log(error);
            this.isUserUpdating = false;
          },
        });
    } else {
      this.isUserUpdating = false;
    }
  }

  submitForm(): void {
    this.isUserUpdating = true;
    this.validationMessages = this.ertUserService.validateERTViewForm(
      this.ertUserViewForm
    );
    if (this.validationMessages.length > 0) {
      this.isUserUpdating = false;
      this.scrollToTop();
      return;
    }

    this.updateCurrentERTUser();
    this.ertUserService
      .updateERTUser(
        this.currentUser,
        Number(this.currentLoggedInUser.facilityId) || 0
      )
      .subscribe({
        next: (_) => {
          this.router.navigate(["/ert-user"]);
          this.isUserUpdating = false;
        },
        error: (error) => {
          this.errorMessage.push(error.error);
          this.scrollToTop();
          this.isUserUpdating = false;
        },
      });
  }

  updateCurrentERTUser(): void {
    this.currentUser.facility =
      this.ertUserViewForm.get("selectedFacility").value;
    this.currentUser.facilityId = this.currentUser.facility?.id;
    this.currentUser.caiEmail = this.ertUserViewForm.get("cai_email").value;
    this.currentUser.isCompletedFCE =
      this.ertUserViewForm.get("isCompletedFCE").value;
    this.currentUser.lastName = this.ertUserViewForm.get("lastName").value;
    this.currentUser.firstName = this.ertUserViewForm.get("firstName").value;
    this.currentUser.fullName =
      `${this.currentUser.firstName} ${this.currentUser.lastName}`.trim();
    this.currentUser.calledBy = this.ertUserViewForm.get("calledBy").value;
    this.currentUser.phone = this.ertUserViewForm.get("phone").value.toString();
    const altPhoneValue = this.ertUserViewForm.get("altPhone")?.value;
    this.currentUser.altPhone = altPhoneValue ? altPhoneValue.toString() : "";
    this.currentUser.hireDate = this.ertUserViewForm.get("hireDate").value;
    this.currentUser.ertDate = this.ertUserViewForm.get("ertDate").value;
    this.currentUser.withdrewDate =
      this.ertUserViewForm.get("inactiveDate").value;
    this.currentUser.comments = this.ertUserViewForm.get("comments").value;
    this.currentUser.isInstructor =
      this.ertUserViewForm.get("isInstructor").value;
    this.currentUser.isHotWorkEntry =
      this.ertUserViewForm.get("isHotWorkEntry").value;
    this.currentUser.isTurnoverAccess =
      this.ertUserViewForm.get("isTurnoverAccess").value;
    this.currentUser.isHurricaneWatch =
      this.ertUserViewForm.get("isHurricaneWatch").value;
    this.currentUser.mgcccNumber =
      this.ertUserViewForm.get("mgcccNumber").value;
    this.currentUser.crewId = this.selectedCrew?.id;
    this.currentUser.unitId = this.selectedUnit?.id;
    this.currentUser.divisionId = this.selectedDivision?.id;
    this.currentUser.titleId = this.selectedTitle?.id;
    this.currentUser.picklistValues = [
      {
        id: this.selectedCrew?.id || 0,
        value: this.selectedCrew ? this.selectedCrew.value : undefined,
        picklistFieldId: this.crewFieldId,
        facilityId: 1,
      },
      {
        id: this.selectedUnit?.id || 0,
        value: this.selectedUnit ? this.selectedUnit.value : undefined,
        picklistFieldId: this.unitFieldId,
        facilityId: 1,
      },
      {
        id: this.selectedDivision?.id || 0,
        value: this.selectedDivision ? this.selectedDivision.value : undefined,
        picklistFieldId: this.divisionFieldId,
        facilityId: 1,
      },
      {
        id: this.selectedTitle?.id || 0,
        value: this.selectedTitle ? this.selectedTitle.value : undefined,
        picklistFieldId: this.titleFieldId,
        facilityId: 1,
      },
    ];
    this.currentUser.teeShirtSize = this.selectedTeeShirtSize;
    this.currentUser.coatSize = this.selectedCoatSize;
    this.currentUser.hatSize = this.selectedHatSize;
    this.currentUser.glovesSize = this.selectedGlovesSize;
    this.currentUser.glassesSize = this.selectedGlassesSize;
    this.currentUser.turnoutJacketSize = this.selectedTurnoutJacketSize;
    this.currentUser.turnoutPantsSize = this.selectedTurnoutPantsSize;
    this.currentUser.boot = this.ertUserViewForm.get("boot").value;
    this.currentUser.turnoutBoot =
      this.ertUserViewForm.get("turnoutBoot").value;
    this.currentUser.modifiedById = this.currentLoggedInUser?.id;
  }

  private scrollToTop() {
    this.renderer.setProperty(document.documentElement, "scrollTop", 0);
    this.renderer.setProperty(document.body, "scrollTop", 0);
  }

  loadKR998ForUser(): void {
    this.ertUserService.getKR998ForUser(Number(this.userNumber)).subscribe({
      next: (kr998Details) => {
        kr998Details.forEach((kr) => {
          kr.crew = this.getLastPostedCrew(kr.kr998.picklistValues);
          kr.kr998.startDateTime = new Date(
            kr.kr998.startDateTime
          ).toLocaleDateString("en-US");
        });
        this.empKR998Details = new MatTableDataSource(kr998Details);
        this.empKR998Details.sort = this.kr998Sort;
        this.empKR998Details.sortingDataAccessor = (item, property) => {
          switch (property) {
            case "company":
              return item.kr998.company;
            case "startDateTime":
              return new Date(item.kr998?.startDateTime);
            default:
              return item[property];
          }
        };
        this.empKR998Details.paginator = this.kr998Paginator;
        this.totalKR998Items = kr998Details.length;
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getLastPostedCrew(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.kr998Service.getValueForField(
      picklistValues,
      this.crewFieldId
    );
    return name;
  }

  deleteEducation(educationId: number): void {
    if (
      window.confirm("Are you sure you want to delete this education record?")
    ) {
      this.educationService
        .deleteEducation(
          educationId,
          Number(this.currentLoggedInUser.facilityId) || 0
        )
        .subscribe({
          next: (_) => {
            this.loadEducationForUser(this.userNumber);
          },
          error: (_) => {},
        });
    }
  }

  deleteKr998(kr998Id: number): void {
    if (window.confirm("Are you sure you want to delete this KR998 record?")) {
      this.kr998Service
        .deleteKr998(kr998Id, Number(this.currentLoggedInUser.facilityId) || 0)
        .subscribe({
          next: (_) => {
            this.loadKR998ForUser();
          },
          error: (_) => {},
        });
    }
  }

  navigateToNewEducationPolicy(): void {
    this.router.navigate(["/ert-education/new-entry"], {
      queryParams: {
        name: this.currentUser.fullName,
        userId: this.currentUser.id,
      },
    });
  }
}
